import Link from './Link';
import type { ILinkProps } from './Link.types';

export type { ILinkProps };
export default Link;
